import {Message} from "./message";

export class OrderChanged implements Message {
  constructor(public orderId: number, public draftId: number) {}
}
